import { render } from "./StudentCardPairings.vue?vue&type=template&id=40e634c4"
import script from "./StudentCardPairings.vue?vue&type=script&lang=js"
export * from "./StudentCardPairings.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3444732531/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__